module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    ref: "bg",
    staticClass: "container__background"
  }, [_c('transition-wrapper', {
    attrs: {
      "appear": true
    }
  }, [(_vm.hasHiddenItems) ? _c('load-more-button', {
    staticClass: "more-button",
    on: {
      "click": function($event) {
        _vm.$emit('load-more-items')
      }
    }
  }) : _vm._e()], 1)], 1), (_vm.items.length > 0) ? _c('transition-group', {
    ref: "list",
    staticClass: "list",
    class: ("is-" + (this.type)),
    attrs: {
      "appear": "appear",
      "tag": "ul"
    },
    on: {
      "enter": _vm.itemEnter
    }
  }, [_vm._l((_vm.items), function(item, index) {
    return (_vm.type === 'news') ? _c('li', {
      key: index,
      staticClass: "story",
      attrs: {
        "data-index": index
      }
    }, [_c('router-link', {
      staticClass: "story-thumb",
      style: (_vm.getBackgroundImage(item)),
      attrs: {
        "to": '/' + _vm.lang + '/news' + item.url
      }
    }), _c('div', {
      staticClass: "story-content"
    }, [_c('div', {
      staticClass: "story-content__info"
    }, [_c('a', {
      staticClass: "story-content__title",
      attrs: {
        "url": '/' + _vm.lang + '/news' + item.url
      }
    }, [_vm._v(_vm._s(item.title || 'Story title'))]), _c('div', {
      staticClass: "story-content__date"
    }, [_vm._v(_vm._s(_vm._f("formatDate")(item.createdAt)))])]), _c('base-button', {
      staticClass: "story-content__link",
      attrs: {
        "url": '/' + _vm.lang + '/news' + item.url,
        "label": _vm.$t('read-article')
      }
    })], 1)], 1) : _vm._e()
  }), _vm._l((_vm.items), function(item, index) {
    return (_vm.type === 'projects') ? _c('li', {
      key: index,
      staticClass: "project",
      attrs: {
        "data-index": index
      }
    }, [_c('router-link', {
      staticClass: "project-link",
      attrs: {
        "to": '/' + _vm.lang + '/projects' + item.url
      }
    }, [_c('div', {
      staticClass: "project-thumb",
      style: (_vm.getBackgroundImage(item))
    }), _c('div', {
      staticClass: "project-content"
    }, [_c('div', {
      staticClass: "project-content__title"
    }, [_vm._v(_vm._s(item.title || 'Project title'))]), _c('div', {
      staticClass: "project-content__cat"
    }, [_vm._v(_vm._s(item.cat))])])])], 1) : _vm._e()
  })], 2) : _c('div', {
    staticClass: "empty-list"
  }, [_c('div', {
    ref: "noNewsMessage",
    staticClass: "empty-list__title"
  }, [_vm._v(_vm._s(_vm.type === 'news' ? _vm.$t('no-news') : _vm.$t('no-projects')))])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-03e719ca","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/list/list.vue
// module id = 463
// module chunks = 0